import {
  GET_ANNOUNCEMENT,
  GET_ANNOUNCEMENT_SUCCESS,
  GET_ANNOUNCEMENT_FAILURE,
  DELETE_ANNOUNCEMENT,
  DELETE_ANNOUNCEMENT_SUCCESS,
  DELETE_ANNOUNCEMENT_FAILURE,
  EDIT_ANNOUNCEMENT,
  EDIT_ANNOUNCEMENT_SUCCESS,
  EDIT_ANNOUNCEMENT_FAILURE,
  ADD_ANNOUNCEMENT,
  ADD_ANNOUNCEMENT_SUCCESS,
  ADD_ANNOUNCEMENT_FAILURE,
} from "../Constants";

export const GetAnnouncement = (payload) => ({
  type: GET_ANNOUNCEMENT,
  payload,
});

export const GetAnnouncementSuccess = (payload) => ({
  type: GET_ANNOUNCEMENT_SUCCESS,
  payload,
});

export const GetAnnouncementFailure = (payload) => ({
  type: GET_ANNOUNCEMENT_FAILURE,
  payload,
});

export const DeleteAnnouncement = (payload) => ({
  type: DELETE_ANNOUNCEMENT,
  payload,
});

export const DeleteAnnouncementSuccess = (payload) => ({
  type: DELETE_ANNOUNCEMENT_SUCCESS,
  payload,
});

export const DeleteAnnouncementFailure = (payload) => ({
  type: DELETE_ANNOUNCEMENT_FAILURE,
  payload,
});

export const EditAnnouncement = (payload) => ({
  type: EDIT_ANNOUNCEMENT,
  payload,
});

export const EditAnnouncementSuccess = (payload) => ({
  type: EDIT_ANNOUNCEMENT_SUCCESS,
  payload,
});

export const EditAnnouncementFailure = (payload) => ({
  type: EDIT_ANNOUNCEMENT_FAILURE,
  payload,
});

export const AddAnnouncement = (payload) => ({
  type: ADD_ANNOUNCEMENT,
  payload,
});

export const AddAnnouncementSuccess = (payload) => ({
  type: ADD_ANNOUNCEMENT_SUCCESS,
  payload,
});

export const AddAnnouncementFailure = (payload) => ({
  type: ADD_ANNOUNCEMENT_FAILURE,
  payload,
});
